import React from 'react';
import PropTypes from 'prop-types';

const SortVertical01 = ({color = 'currentColor', ...props}) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 9.99988L4 12.9999L1 9.99988M1 3.99988L4 0.999878L7 3.99988"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

SortVertical01.propTypes = {
  color: PropTypes.string,
};

export default SortVertical01;
